import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLoadingContext } from "../../context/LoadingContext";
import SpinnerWithText from "./SpinnerWithText";
const LoadingOverlay = ({
  isLoading: propIsLoading = false,
  isBlur = true,
  isTransparent = true,
  isLogo = true,
}) => {
  const weldaGroupLogoSrc = "/images/logos/aw-tech/aw-tech-logo.png";
  const { t } = useTranslation();
  const {
    isLoading: contextIsLoading,
    loadingReason,
    isLoadingVisible,
  } = useLoadingContext();
  const isLoading = contextIsLoading || propIsLoading;

  if (!isLoading || !isLoadingVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: `rgba(255, 255, 255, ${isTransparent ? 0.7 : 1})`,
        backdropFilter: isBlur ? `blur(1px)` : "none",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="d-flex flex-column justify-content-center align-items-center gap-4">
        {/* {isLogo && (
          <img
            src={weldaGroupLogoSrc}
            alt="Logo"
            className="glowing-logo"
            style={{
              maxWidth: "200px",
            }}
          />
        )} */}
        <SpinnerWithText
          text={
            loadingReason ? loadingReason : t("frontend.common.loading.text")
          }
        />
      </div>
    </div>
  );
};

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool,
  blurAmount: PropTypes.string,
};

export default LoadingOverlay;
